import PageModel from '@mm/state/model/PageModel';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import { getFbPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { useSelector } from 'react-redux';
import getPromoterGlobalJSValue from '../../build/constants/getPromoterGlobalJSValue';

export const usePromoterJSCode = (
  promoter: PromoterModel | undefined,
  page?: PageModel,
) => {
  const fbPageRemoteId = useSelector((state: StoreState) =>
    getFbPageIdSelector(state),
  );
  const globalJavascriptBaseUrl = useSelector(
    (state: StoreState) => state.env.globalJavascriptBaseUrl,
  );

  if (
    promoter &&
    (page || ['customer_chat', 'getemails'].includes(promoter.type))
  ) {
    if (promoter.type === 'link' || promoter.type === 'instagram_link') {
      const slug = promoter && promoter.slug;
      return slug ? promoter.slugLink : promoter.tokenLink;
    }

    return getPromoterGlobalJSValue({
      pageId: fbPageRemoteId,
      type: promoter.type,
      ref: promoter.searchToken,
      enableDataApi: true,
      globalJavascriptBaseUrl,
    });
  }

  return '';
};
